import React, { JSX } from 'react';
import { getFormatDateFromStoreDate } from 'shared-components';
import { Section } from '../../../../Finger/Section';
import { getFingerStatus, getVisible, hasDeleted } from '../../../../../utilities/documents';
import FingerWithApprove from '../../../../atoms/finger-with-approve';
import NoDocuments from '../../../../atoms/no-doc-placeholder';

import { UserRole } from '../../../../../store/auth/types';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { DocAccessType, IFollowUpDocuments, VisaVignetteDocList } from '../../../../../types';
import { useTranslation } from "react-i18next";

interface IProps {
  userAccess?: DocAccessType;
  documents: IFollowUpDocuments['beforeTravel']['visaVignette'];
  userRole?: UserRole;

  canResume: boolean;
  canUpload: boolean;
  canOpen: boolean;
  canApprove: boolean;
  canReject: boolean;
  isDeleting: boolean;

  onUploadClick: (docKey: string) => void;
  onOpenClick: (docKey: string) => void;
  onApproveClick: (docKey: string) => void;
  onRejectClick: (docKey: string) => void;
  onRescindRejectClick: (docKey: string) => void;
  onDeleteClick: (docKey: string) => void;
  onAcknowledgeClick: (docKey: string) => void;
}
const VisaVignette = (props: IProps): JSX.Element => {
    const { t } = useTranslation('common');
  const { documents: visaVignetteDocs, userAccess, userRole } = props;

  const visibleDocs = getVisible({ documentsHash: visaVignetteDocs, userAccess, userRole });

  const hasDocs = visibleDocs.length > 0;
  const hasDeletedDocs = hasDeleted(visaVignetteDocs);

  const docNodes: React.ReactNode[] = [];

  if (!hasDocs && !hasDeletedDocs) {
    return null;
  }

  if (userAccess && !hasDocs) {
    return null;
  }

  const getDocumentCount = (docs: object, index: number): string => {
    if (Object.keys(docs ?? {}).length <= 1) return '';

    return index > 0 ? String(index + 1) : '';
  };

  if (hasDocs) {
    docNodes.push(
      ...visibleDocs.map((visaVignette: VisaVignetteDocList, visaVignetteIndex: number) => {
        const { key: docKey, item } = visaVignette;

        return (
          <FingerWithApprove
            id={`visa-vignette-${docKey}`}
            key={`visa-vignette-${docKey}`}
            status={getFingerStatus(item)}
            isProcessingPdf={item.isProcessingPdf}
            reason={item.reason}
            fileCount={item.signedUrls && item.signedUrls.length > 0 ? item.signedUrls.length : 0}
            fileNames={item.fileNames}
            label={t('common:studentVisaEvisa', { getDocumentCount: getDocumentCount(visaVignetteDocs, visaVignetteIndex) })}
            canUpload={props.canUpload}
            canOpen={props.canOpen}
            canApprove={props.canApprove}
            canReject={props.canReject}
            isDeleting={props.isDeleting}
            canAcknowledge={false}
            onUploadClick={() => {
              props.onUploadClick(docKey);
            }}
            onOpenClick={() => {
              props.onOpenClick(docKey);
            }}
            onApproveClick={() => {
              props.onApproveClick(docKey);
            }}
            onRejectClick={() => {
              props.onRejectClick(docKey);
            }}
            onRescindRejectClick={() => {
              props.onRescindRejectClick(docKey);
            }}
            onDeleteClick={() => {
              props.onDeleteClick(docKey);
            }}
            onAcknowledgeClick={() => {}}
            userRole={props.userRole}
            deletedByTTL={item.deletedByTTL}
          >
            <SummaryRow
              key={`before-travel-start-date-${docKey}`}
              label={t('common:visaStartDate')}
              fullLabel="What is the visa start date?"
              value={getFormatDateFromStoreDate(item.visaStartDate)}
            />

            <SummaryRow
              key={`before-travel-end-date-${docKey}`}
              label={t('common:visaEndDate')}
              fullLabel="What is the visa end date?"
              value={getFormatDateFromStoreDate(item.visaEndDate)}
            />

            <SummaryRow
              key={`before-travel-arrive-date-${docKey}`}
              label={t('common:arriveDate')}
              fullLabel="What date do you plan to arrive in the UK?"
              value={getFormatDateFromStoreDate(item.arrivalDate)}
            />
          </FingerWithApprove>
        );
      }),
    );
  }

  return (
    <>
      <Section
        key={`before-travel`}
        label={t('common:visaProofPassportVignetteOrEvisa')}
        canEdit={false}
        edit={() => {
          // props.onResume('history/step-1');
        }}
        warning={''}
      >
        {hasDocs ? docNodes : <NoDocuments />}
      </Section>
    </>
  );
};

export default VisaVignette;
